import {
  mainnet,
  goerli,
  arbitrum,
  arbitrumGoerli,
  arbitrumNova,
  aurora,
  auroraTestnet,
  avalanche,
  avalancheFuji,
  base,
  baseGoerli,
  boba,
  bronos,
  bronosTestnet,
  bsc,
  bscTestnet,
  bxn,
  bxnTestnet,
  canto,
  celo,
  celoAlfajores,
  classic,
  confluxESpace,
  confluxESpaceTestnet,
  crossbell,
  dfk,
  dogechain,
  edgeware,
  edgewareTestnet,
  eos,
  eosTestnet,
  ekta,
  ektaTestnet,
  evmos,
  evmosTestnet,
  fantom,
  fantomTestnet,
  fibo,
  filecoin,
  filecoinCalibration,
  filecoinHyperspace,
  flare,
  flareTestnet,
  fuse,
  fuseSparknet,
  gobi,
  gnosis,
  gnosisChiado,
  haqqMainnet,
  haqqTestedge2,
  harmonyOne,
  iotex,
  iotexTestnet,
  klaytn,
  linea,
  lineaTestnet,
  mantle,
  mantleTestnet,
  metis,
  metisGoerli,
  mev,
  mevTestnet,
  modeTestnet,
  moonbaseAlpha,
  moonbeam,
  moonriver,
  neonDevnet,
  neonMainnet,
  nexilix,
  nexi,
  oasys,
  okc,
  optimism,
  optimismGoerli,
  polygon,
  polygonMumbai,
  polygonZkEvm,
  polygonZkEvmTestnet,
  pulsechain,
  pulsechainV4,
  qMainnet,
  qTestnet,
  rollux,
  rolluxTestnet,
  ronin,
  saigon,
  scrollSepolia,
  scrollTestnet,
  sepolia,
  shardeumSphinx,
  skaleCalypso,
  skaleCalypsoTestnet,
  skaleChaosTestnet,
  skaleCryptoBlades,
  skaleCryptoColosseum,
  skaleEuropa,
  skaleEuropaTestnet,
  skaleExorde,
  skaleHumanProtocol,
  skaleNebula,
  skaleNebulaTestnet,
  skaleRazor,
  skaleTitan,
  skaleTitanTestnet,
  syscoin,
  syscoinTestnet,
  songbird,
  songbirdTestnet,
  taikoTestnetSepolia,
  taraxa,
  taraxaTestnet,
  telos,
  telosTestnet,
  thunderTestnet,
  wanchain,
  wanchainTestnet,
  xdc,
  xdcTestnet,
  zetachainAthensTestnet,
  zkSync,
  zkSyncTestnet,
  zora,
  zoraTestnet,
} from 'wagmi/chains';

export const APP_CHAINS = [
  mainnet,
  goerli,
  arbitrum,
  arbitrumGoerli,
  arbitrumNova,
  aurora,
  auroraTestnet,
  avalanche,
  avalancheFuji,
  base,
  baseGoerli,
  boba,
  bronos,
  bronosTestnet,
  bsc,
  bscTestnet,
  bxn,
  bxnTestnet,
  canto,
  celo,
  celoAlfajores,
  classic,
  confluxESpace,
  confluxESpaceTestnet,
  crossbell,
  dfk,
  dogechain,
  edgeware,
  edgewareTestnet,
  eos,
  eosTestnet,
  ekta,
  ektaTestnet,
  evmos,
  evmosTestnet,
  fantom,
  fantomTestnet,
  fibo,
  filecoin,
  filecoinCalibration,
  filecoinHyperspace,
  flare,
  flareTestnet,
  fuse,
  fuseSparknet,
  gobi,
  gnosis,
  gnosisChiado,
  haqqMainnet,
  haqqTestedge2,
  harmonyOne,
  iotex,
  iotexTestnet,
  klaytn,
  linea,
  lineaTestnet,
  mantle,
  mantleTestnet,
  metis,
  metisGoerli,
  mev,
  mevTestnet,
  modeTestnet,
  moonbaseAlpha,
  moonbeam,
  moonriver,
  neonDevnet,
  neonMainnet,
  nexilix,
  nexi,
  oasys,
  okc,
  optimism,
  optimismGoerli,
  polygon,
  polygonMumbai,
  polygonZkEvm,
  polygonZkEvmTestnet,
  pulsechain,
  pulsechainV4,
  qMainnet,
  qTestnet,
  rollux,
  rolluxTestnet,
  ronin,
  saigon,
  scrollSepolia,
  scrollTestnet,
  sepolia,
  shardeumSphinx,
  skaleCalypso,
  skaleCalypsoTestnet,
  skaleChaosTestnet,
  skaleCryptoBlades,
  skaleCryptoColosseum,
  skaleEuropa,
  skaleEuropaTestnet,
  skaleExorde,
  skaleHumanProtocol,
  skaleNebula,
  skaleNebulaTestnet,
  skaleRazor,
  skaleTitan,
  skaleTitanTestnet,
  syscoin,
  syscoinTestnet,
  songbird,
  songbirdTestnet,
  taikoTestnetSepolia,
  taraxa,
  taraxaTestnet,
  telos,
  telosTestnet,
  thunderTestnet,
  wanchain,
  wanchainTestnet,
  xdc,
  xdcTestnet,
  zetachainAthensTestnet,
  zkSync,
  zkSyncTestnet,
  zora,
  zoraTestnet,
];
